import { render, staticRenderFns } from "./DetailsInformation.vue?vue&type=template&id=4fde2124"
import script from "./DetailsInformation.vue?vue&type=script&lang=js"
export * from "./DetailsInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports